import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Morph',
    description: 'Morph is a landscape and aerial photographic practice working at the edges of coastlines, ice and open ground.',
    placeholder: 'Scroll or drag to explore the hang.',
    url: getOrigin()
}

export const NAV_LINKS = [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]

export const STUDIO = {
    email: 'studio@morph.photography',
    phone: '+44 20 7946 0142',
    address: ['Unit 7, Vaults Yard', 'Bermondsey, London SE1 3UN'],
    hours: 'Monday to Thursday, 09:00 to 18:00 GMT',
    socials: [
        { label: 'Instagram', href: 'https://instagram.com' },
        { label: 'Behance', href: 'https://behance.net' },
        { label: 'LinkedIn', href: 'https://linkedin.com' }
    ]
}
